export { default } from './DayNames';